import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';
const serverUrl = publishObjectPath.serverUrl;

export class TemporaryWorkServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  public getTemporaryWorkPermit(params: any = {}) {
    return this.rSerivce.serverObj.request({
      method: 'post',
      url: serverUrl + '/api/yunnan/temporaryWorkPermit/page',
      data: params,
    });
  }

  public temporaryWorkPermitSaveOrUpdateData(params: any = {}) {
    return this.rSerivce.serverObj.request({
      method: 'post',
      url: serverUrl + '/api/yunnan/temporaryWorkPermit/saveOrUpdateData',
      data: params,
    });
  }

  public removeTemporaryWorkPermit(id: any) {
    const url = serverUrl + '/api/yunnan/temporaryWorkPermit/delete?idList=' + id;
    return this.rSerivce.serverObj.delete(url);
  }
}
